import React from 'react'
import { string, number, bool } from 'prop-types'
import isUndefined from 'lodash/isUndefined'

const StatCard = ({ title, retryLink, total, last24Total, showLoading }) => {
  if (showLoading) {
    return (
      <div className="Stat Stat--loading">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Doing Science...</span>
        </div>
        <div className="text-primary mt-3">Doing Science...</div>
      </div>
    )
  }

  return (
    <div className="Stat">
      <div className="Stat__title">
        {title}
        {retryLink && (
          <a href={retryLink}>
            <i className="fa fa-refresh" aria-hidden="true"/> Retry
          </a>
        )}
      </div>
      <div className="Stat__body">
        <div className="Stat__item">
          <div className="Stat__item__title">Total</div>
          <div className="Stat__item__result">{total}</div>
        </div>
        {!isUndefined(last24Total) && (
          <div className="Stat__item">
            <div className="Stat__item__title">Last 24 hours</div>
            <div className="Stat__item__result">{last24Total}</div>
          </div>
        )}
      </div>
    </div>
  )
}

StatCard.propTypes = {
  title: string.isRequired,
  retryLink: string,
  total: number.isRequired,
  last24Total: number,
  showLoading: bool,
}

export default StatCard
